// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3DMpV","choiceBoxes":"toolbarselects_choiceBoxes__37Bcx","simpleField":"toolbarselects_simpleField__1Wu8f"};